<div class="side-modal-controller" [class.open]="isOpen">
  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'left-center')" style="margin: 0">
    <div class="side-modal-btn" (click)="toggleModal()"><i class="material-icons" style="font-size: 18px; color: #55647B">{{isOpen ? 'chevron_right' : iconName}}</i></div>
    <div class="--g-tooltip tooltip-background">{{ isOpen ? 'Close' : 'Help'}}</div>
  </div>
</div>
<div class="side-modal-background" [class.open]="isOpen" (click)="toggleModal()">
  <div class="img-area" *ngIf="page === 'contents'">
    <div class="image-container"><img #imageRef [src]="imgSrc" (load)="setLoadEvent()"/>
      <div class="overlay"></div>
    </div>
  </div>
</div>
<div class="side-modal" [class.open]="isOpen">
  <ng-container *ngIf="page === 'list'">
    <div class="modal-header">
      <div class="title">FAQ Section</div>
    </div>
    <div class="modal-body">
      <ul>
        <li class="subtitle" *ngFor="let page of pageList" (click)="onClickPage($event, page)"> 
          <div class="subtitle-content">
            <div>{{ page.name }}</div><i class="material-icons transition fold-icon" *ngIf="page.subPages.length > 0" [class.rotate-reverse]="!page.isFold" (click)="onClickPage($event, page)">keyboard_arrow_down</i>
          </div>
          <ul *ngIf="page.subPages.length > 0 && !page.isFold">
            <li *ngFor="let subPage of page.subPages" (click)="goToContent($event, subPage.pageName)">{{ subPage.name }}</li>
          </ul>
        </li>
      </ul>
    </div>
  </ng-container>
  <ng-container *ngIf="page === 'contents'">
    <div class="modal-header"><i class="material-icons" (click)="changePage('list')" style="font-size:24px;">arrow_back</i></div>
    <ng-container [ngSwitch]="selectedContent">
      <c_side_modal_site_note_component *ngSwitchCase="'site-note'"></c_side_modal_site_note_component>
      <c_side_modal_direction_define_component *ngSwitchCase="'direction-define'"></c_side_modal_direction_define_component>
      <c_side_modal_direction_features_component *ngSwitchCase="'direction-features'" (showPosition)="showPosition($event)" (hidePosition)="hidePosition()"></c_side_modal_direction_features_component>
      <c_side_modal_direction_procedures_component *ngSwitchCase="'direction-procedures'" (showPosition)="showPosition($event)" (hidePosition)="hidePosition()"></c_side_modal_direction_procedures_component>
      <c_side_modal_approval_process_component *ngSwitchCase="'approval-process'"></c_side_modal_approval_process_component>
      <c_side_modal_direction_common_component *ngSwitchCase="'direction-common'"></c_side_modal_direction_common_component>
    </ng-container>
  </ng-container>
</div>